// extracted by mini-css-extract-plugin
export default {"staticRouteIntro":"StaticRouteIntro_staticRouteIntro__XjZJv"};